import { useMutation } from "@tanstack/react-query";
import { apiCall } from "@/lib/api";

export type ImportReport = {
  dry_run: boolean;
  csvs_leidos: Record<string, number>;
  clientes: { a_crear: number; creados: number; existentes: number; descartados_estado: number };
  planes: { a_crear: number; creados: number; existentes: number };
  contratos: { a_crear: number; creados: number; sin_red_match: number };
  facturas_pendientes: { a_crear: number; creadas: number };
  warnings: string[];
  errores: { categoria: string; ref: string; mensaje: string }[];
  errores_total: number;
};

export function usePreviewImport() {
  return useMutation({
    mutationFn: (directorio: string) =>
      apiCall<ImportReport>("post", "/api/v1/admin/mikrowisp-import/preview", {
        json: { directorio },
      }),
  });
}

export function useExecuteImport() {
  return useMutation({
    mutationFn: (directorio: string) =>
      apiCall<ImportReport>("post", "/api/v1/admin/mikrowisp-import/execute", {
        json: { directorio },
      }),
  });
}
